import React from "react";
import "./Header.scss";

export default function Header() {
  return (
    <>
      {/* Name */}
      <div className="header-content">
        <h2>Anshumaan Kumar Prasad</h2>
        <h2>Anshumaan Kumar Prasad</h2>
      </div>

      {/* Headline */}
      <div>
        <h3>A Junior at Information Technology & Services</h3>
      </div>
    </>
  );
}
